module.exports = __webpack_public_path__ + "img/Hire3XLogo.1ccb1201.svg";